import React from 'react';
import { ReviewContactDetails } from 'pages/components';

const ReferralsContactReview = (props) => (
  <ReviewContactDetails {...props} />
);

export default ReferralsContactReview;
